import { BaseViewModel } from '@apis/model/BaseViewModel';
import { BaseResponse } from '@ul/api/lib/models/BaseResponse';

export const toForceLogoutViewModel = (forceLogoutResponse: BaseResponse): BaseViewModel => {
    const { success, responseCode } = forceLogoutResponse;
    return {
        success,
        responseCode,
    };
};
